import React from 'react';

export const EmployeeDetailsScreen = () => {
    return (
        <div>
            
        </div>
    )
}
